import { supabase } from "@/lib/supabase";

export interface SocialLink {
  id: number;
  platform: string;
  label: string;
  url: string;
  icon: string;
  color: string;
  isActive: boolean;
  sortOrder: number;
}

function mapRow(row: Record<string, unknown>): SocialLink {
  return {
    id: row.id as number,
    platform: row.platform as string,
    label: row.label as string,
    url: (row.url as string) || "",
    icon: row.icon as string,
    color: (row.color as string) || "#D4AF37",
    isActive: (row.is_active as boolean) ?? true,
    sortOrder: (row.sort_order as number) || 0,
  };
}

export const socialLinksStore = {
  async getAll(): Promise<SocialLink[]> {
    const { data, error } = await supabase
      .from("social_links")
      .select("*")
      .order("sort_order", { ascending: true });
    if (error) {
      console.error("socialLinksStore.getAll error:", error);
      return [];
    }
    return (data || []).map(mapRow);
  },

  async getActive(): Promise<SocialLink[]> {
    const { data, error } = await supabase
      .from("social_links")
      .select("*")
      .eq("is_active", true)
      .order("sort_order", { ascending: true });
    if (error) {
      console.error("socialLinksStore.getActive error:", error);
      return [];
    }
    return (data || []).map(mapRow);
  },

  async update(id: number, fields: Partial<Omit<SocialLink, "id">>): Promise<void> {
    const db: Record<string, unknown> = {};
    if (fields.url !== undefined) db.url = fields.url;
    if (fields.label !== undefined) db.label = fields.label;
    if (fields.isActive !== undefined) db.is_active = fields.isActive;
    if (fields.sortOrder !== undefined) db.sort_order = fields.sortOrder;
    db.updated_at = new Date().toISOString();

    const { error } = await supabase
      .from("social_links")
      .update(db)
      .eq("id", id);
    if (error) {
      console.error("socialLinksStore.update error:", error);
    }
  },

  async updateAll(links: SocialLink[]): Promise<void> {
    const updates = links.map((link) =>
      supabase
        .from("social_links")
        .update({
          url: link.url,
          label: link.label,
          is_active: link.isActive,
          sort_order: link.sortOrder,
          updated_at: new Date().toISOString(),
        })
        .eq("id", link.id)
    );
    await Promise.all(updates);
  },
};
